import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";

import "./styles.css";
import FunnelMetrics from "./FunnelMetrics";
import EngagementMetrics from "./EngagementMetrics";
import TopContent from "./TopContent";
import AcquisitionMetrics from "./AcquisitionReports";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

const Overview = () => {
  return (
    <div>
      <FunnelMetrics />
      <EngagementMetrics />
      <div className="two-column-wrapper">
        <div style={{ maxWidth: "50%", width: "50%", minWidth: "50%" }}>
          <TopContent />
        </div>
        <div style={{ maxWidth: "50%", width: "50%", minWidth: "50%" }}>
          <AcquisitionMetrics />
        </div>
      </div>
    </div>
  );
};

export default Overview;
